/**
 * Password Policy Constants
 * Must match server-side policy in server/utils/password-validator.js
 */
import * as Yup from 'yup';

export const PASSWORD_POLICY = {
    minLength: 12,
    maxLength: 128,
    requireUppercase: true,
    requireLowercase: true,
    requireDigit: true,
    requireSpecialChar: true,
};

export const PASSWORD_REQUIREMENTS = [
    { key: 'length', label: 'At least 12 characters', test: (pwd) => pwd.length >= 12 },
    { key: 'uppercase', label: 'At least one uppercase letter (A-Z)', test: (pwd) => /[A-Z]/.test(pwd) },
    { key: 'lowercase', label: 'At least one lowercase letter (a-z)', test: (pwd) => /[a-z]/.test(pwd) },
    { key: 'digit', label: 'At least one number (0-9)', test: (pwd) => /[0-9]/.test(pwd) },
    { key: 'special', label: 'At least one special character (!@#$%^&*...)', test: (pwd) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(pwd) },
];

/**
 * Yup validation schema for password field
 */
export const passwordValidationSchema = Yup.string()
    .required('Password is required')
    .min(PASSWORD_POLICY.minLength, `Password must be at least ${PASSWORD_POLICY.minLength} characters`)
    .max(PASSWORD_POLICY.maxLength, `Password must not exceed ${PASSWORD_POLICY.maxLength} characters`)
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/, 'Password must contain at least one special character');

/**
 * Create password validation schema with repeat password
 */
export const createPasswordValidationSchema = (passwordFieldName = 'newPassword', repeatFieldName = 'passwordRepeat') => {
    return {
        [passwordFieldName]: passwordValidationSchema,
        [repeatFieldName]: Yup.string()
            .required('Please confirm your password')
            .oneOf([Yup.ref(passwordFieldName)], 'Passwords must match'),
    };
};
